import React from "react";
import "./Experience.css";
import Experience from "../Components/Experience/Experience";

function ExperiencePage() {
	return (
		<div className="pageContent">
			<h1>Experience</h1>
			<Experience />
		</div>
	);
}

export default ExperiencePage;
